import { orderBy as n } from "es-toolkit/compat";
import { orderBy as u } from "natural-orderby";
const N = {
  ASCENDING: "asc",
  DESCENDING: "desc"
}, f = (r, t) => typeof r[t] == "string" ? r[t].toLowerCase() : r[t], c = (r, t, o = N.ASCENDING, e) => e ? n(r, [t], o) : n(r, (s) => f(s, t), o), d = (r, t, o = N.ASCENDING, e) => e ? u(r, t, [o]) : u(r, (s) => f(s, t), o);
export {
  N as SortDirection,
  N as default,
  d as naturalSortByProperty,
  c as sortByProperty
};
//# sourceMappingURL=SortUtils.js.map
